/**
 * Auto-generated by Style Dictionary from DTCG tokens.
 * DO NOT EDIT — run `nx run tokens:code` to regenerate.
 *
 * @generated
 */

export const breakpointsLg = '1200px' as const;

export const breakpointsMd = '900px' as const;

export const breakpointsSm = '600px' as const;

export const breakpointsXl = '1536px' as const;

export const breakpointsXs = '0px' as const;
